import { Switch } from "antd";
import React from "react";

export const StyledSwitchSHB = () => {

    const onChange = (key) => {
        console.log(key);
    };

    return (
        <>
            <div>
                <Switch defaultChecked onChange={onChange} />
            </div>
        </>
    )
}